/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
// import { uniq, sortBy, groupBy } from 'lodash';
import { sortBy, uniq } from 'lodash';
import { groupIndicator } from '@/util/helper';
import ApiServices from '@/modules/data-layer/services/ApiServices';
import VueCookies from 'vue-cookies';

const normalizeDatasourceName = (value) => String(value || '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

const getDatasourceId = (source) => {
  const id = Number(
    source?.id
    ?? source?.['datasource_id']
    ?? source?.datasourceId
    ?? source?.dataSource
    ?? source?.datasource,
  );

  return Number.isFinite(id) ? id : null;
};

const getDatasourceNames = (source) => [
  source?.datasource,
  source?.['full_name'],
  source?.name,
  source?.['short_name'],
]
  .map(normalizeDatasourceName)
  .filter(Boolean);

const getDatasourceKeys = (source) => {
  const sourceId = getDatasourceId(source);
  const keys = getDatasourceNames(source).map((name) => `name:${name}`);

  if (sourceId !== null) {
    keys.push(`id:${sourceId}`);
  }

  return keys;
};

export default {
  data() {
    return {
      defaultIndicator: '',
      defaultDataSource: '',
      defaultLocation: '',
      defaultYear: '2016',
      defaultIndicatorDropdown: [],
      defaultDataSourceDropdown: [],
      defaultLocationDropdown: [],
      defaultYearDropdown: [],
      cpIsLoading: false,
      additionalLocation: [
        {
          id: 2,
          name: 'North-Central',
          parent: 1,
          level: 2,
          created_at: '2022-10-20T09:08:41.900629Z',
          updated_at: '2022-10-20T09:08:41.900636Z',
        },
        {
          id: 3,
          name: 'North-East',
          parent: 1,
          level: 2,
          created_at: '2022-10-20T09:08:41.901842Z',
          updated_at: '2022-10-20T09:08:41.901848Z',
        },
        {
          id: 4,
          name: 'North-West',
          parent: 1,
          level: 2,
          created_at: '2022-10-20T09:08:41.902790Z',
          updated_at: '2022-10-20T09:08:41.902797Z',
        },
        {
          id: 5,
          name: 'South-East',
          parent: 1,
          level: 2,
          created_at: '2022-10-20T09:08:41.903856Z',
          updated_at: '2022-10-20T09:08:41.903866Z',
        },
        {
          id: 6,
          name: 'South-South',
          parent: 1,
          level: 2,
          created_at: '2022-10-20T09:08:41.905143Z',
          updated_at: '2022-10-20T09:08:41.905153Z',
        },
        {
          id: 7,
          name: 'South-West',
          parent: 1,
          level: 2,
          created_at: '2022-10-20T09:08:41.906410Z',
          updated_at: '2022-10-20T09:08:41.906420Z',
        },
      ],
    };
  },
  watch: {
    // The is the updated the control panels dropdown as indicator are gotten from the API
    // in the background (async)
    dlGetAvailableIndicators(newValue) {
      const filteredIndicators = this.filterCustomDashboardIndicators(newValue);
      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'indicator',
        payload: groupIndicator(filteredIndicators, 'program_area'),
      });
    },
  },
  methods: {
    isCustomDashboardActive() {
      return this.$store?.state?.CUSTOM_DASHBOARD_STORE?.customDashboard === true;
    },
    cpGetAvailableYears(dataValues) {
      const years = dataValues?.map((item) => item.period);
      const uniqueYears = uniq(years);
      return sortBy(uniqueYears);
    },
    getCustomDashboardIndicatorIds() {
      const customConfig = VueCookies.get('customDashboardConfig');
      const indicatorIds = customConfig?.indicators;

      if (!Array.isArray(indicatorIds) || indicatorIds.length === 0) {
        return [];
      }

      return indicatorIds.map((id) => Number(id)).filter((id) => Number.isFinite(id));
    },
    filterCustomDashboardIndicators(indicators = []) {
      if (!this.isCustomDashboardActive()) {
        return indicators;
      }

      const indicatorIds = this.getCustomDashboardIndicatorIds();

      if (indicatorIds.length === 0) {
        return indicators;
      }

      return indicators.filter((indicator) => indicatorIds.includes(Number(indicator.id)));
    },
    getSelectedIndicatorIds(indicator = this.payload?.indicator) {
      const selectedIndicators = Array.isArray(indicator) ? indicator : [indicator];

      return selectedIndicators
        .map((item) => Number(item?.id ?? item))
        .filter((id) => Number.isFinite(id));
    },
    getDatasourceIntersection(datasourceGroups = []) {
      if (datasourceGroups.length <= 1) {
        return datasourceGroups[0] || [];
      }

      const remainingGroupKeys = datasourceGroups.slice(1).map(
        (group) => new Set(group.flatMap(getDatasourceKeys)),
      );

      return datasourceGroups[0].filter((source) => {
        const sourceKeys = getDatasourceKeys(source);
        return remainingGroupKeys.every(
          (groupKeys) => sourceKeys.some((key) => groupKeys.has(key)),
        );
      });
    },
    async getDataSourcesForSelectedIndicators(indicator = this.payload?.indicator) {
      const indicatorIds = this.getSelectedIndicatorIds(indicator);

      if (indicatorIds.length === 0) {
        return [];
      }

      const datasourceGroups = await Promise.all(
        indicatorIds.map((indicatorId) => this.getDataSourcesFromIndicator(indicatorId)),
      );

      return this.getDatasourceIntersection(datasourceGroups);
    },
    getDatasourceAvailabilityOptions(availableDataSources = []) {
      const availableIds = new Set(
        availableDataSources
          .map(getDatasourceId)
          .filter((id) => id !== null),
      );
      const availableNames = new Set(
        availableDataSources.flatMap(getDatasourceNames),
      );
      const dashboardDataSources = this.dlGetDashboardDataSource();
      const sourceList = dashboardDataSources.length > 0 ? dashboardDataSources : availableDataSources;

      return sourceList.map((source) => {
        const sourceId = getDatasourceId(source);
        const sourceNames = getDatasourceNames(source);
        const isAvailable = (
          (sourceId !== null && availableIds.has(sourceId))
          || sourceNames.some((name) => availableNames.has(name))
        );

        return {
          ...source,
          isAvailable,
          datasourceAvailable: isAvailable,
          availabilityLabel: isAvailable ? 'Available' : 'Not Available',
          $isDisabled: !isAvailable,
        };
      });
    },
    setUpControlPanelDropDown() {
      // debugger;
      const filteredIndicators = this.filterCustomDashboardIndicators(this.dlGetAvailableIndicators);
      this.defaultIndicatorDropdown = groupIndicator(filteredIndicators, 'program_area');

      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'indicator',
        payload: this.defaultIndicatorDropdown,
      });

      this.defaultDataSourceDropdown = this.dlGetDashboardDataSource();

      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'datasource',
        payload: this.defaultDataSourceDropdown,
      });

      this.defaultLocationDropdown = this.dlGetLocation({
        level: 3,
      });

      const location = this.dlGetLocation(1); // get nigerian Location object
      // add nigeria to the top of the array
      this.defaultLocationDropdown.unshift(location);

      this.defaultDataSourceDropdown = this.dlGetDashboardDataSource();

      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'location',
        payload: this.defaultLocationDropdown,
      });
    },

    setICSDatasources(datasources) {
      this.$store.commit('MSDAT_STORE/UPDATE_IDC_DATASOURCEs', {
        key: 'datasource',
        payload: datasources,
      });
    },
    setDefaults() {
      const { query } = this.$route;
      const {
        indicator: queryIndicator,
        datasource: queryDatasource,
        location: queryLocation,
        // year: queryYear,
      } = query;

      // Check if query parameters for indicator, datasource, location, and year are present
      // const hasQueryParams = queryIndicator !== undefined
      //   || queryDatasource !== undefined
      //   || queryLocation !== undefined
      //   || queryYear !== undefined;

      this.defaultIndicator = queryIndicator
        ? this.dlGetIndicator(Number(queryIndicator))
        : this.dlGetIndicator(this.$store.state.MSDAT_STORE.default.indicator);

      this.defaultDataSource = queryDatasource
        ? this.dlGetDataSource(Number(queryDatasource))
        : this.dlGetDataSource(this.$store.state.MSDAT_STORE.default.datasource);

      this.defaultLocation = queryLocation
        ? this.dlGetLocation(Number(queryLocation))
        : this.dlGetLocation(this.$store.state.MSDAT_STORE.default.location);
    },

    async setYearDropdown(
      indicatorID = this.defaultIndicator.id,
      dataSourceID = this.defaultDataSource.id,
      locationID = this.defaultLocation.id,
    ) {
      const { data } = await ApiServices.getPeriod({
        indicator: indicatorID,
        datasource: dataSourceID || this.this.$route.query.datasource,
        location: locationID,
      });

      const years = data.periods;
      return years.sort((a, b) => b - a);
    },
    // get years by datasource
    async setYearDropdownByDatasource(dataSourceID = this.defaultDataSource.id) {
      const data = await this.queryDBForYearByDs(dataSourceID);
      // debugger;
      // const onlyYearData = data?.filter((item) => {
      //   if (isDataYearly(item.period)) {
      //     return item.period;
      //   }
      //   return false;
      // });
      // const years = onlyYearData?.map((item) => item.period);
      // const uniqueYears = uniq(years);
      return data.sort((a, b) => b - a);
    },

    /**
     * Method to set the location dropdown based on the selected data source and indicator.
     * It fetches available locations from the database and updates the store with the unique locations.
     *
     * @param {number} dataSourceID - The ID of the selected data source. Defaults to the default data source ID.
     * @param {number} indicatorID - The ID of the selected indicator. Defaults to the default indicator ID.
     * @param {number} controlIndex - The index of the control to update. Defaults to 0.
     */

    async setLocationDropdown(
      dataSourceID = this.defaultDataSource.id,
      indicatorID = this.defaultIndicator.id,
      // eslint-disable-next-line no-unused-vars
      controlIndex = 0,
    ) {
      // Return if either dataSourceID or indicatorID is not provided
      if (!dataSourceID || !indicatorID) return;

      let data = [];

      // Fetch available locations for each indicator if indicatorID is an array
      if (Array.isArray(indicatorID)) {
        for (const ind of indicatorID) {
          data = data.concat(await this.queryDBForAvailableLocation(dataSourceID, ind));
        }
        // Fetch available locations for each data source if dataSourceID is an array
      } else if (Array.isArray(dataSourceID)) {
        for (const dat of dataSourceID) {
          data = data.concat(await this.queryDBForAvailableLocation(dat, indicatorID));
        }
        // Fetch available locations for the given dataSourceID and indicatorID
      } else {
        data = await this.queryDBForAvailableLocation(dataSourceID, indicatorID);
      }

      const uniqueById = Array.from(new Map(data.map((item) => [item.id, item])).values());
      // Commit the unique locations to the store
      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'location',
        payload: uniqueById.sort((a, b) => a.id - b.id),
      });

      // Set the default location (Nigeria) in the store
      // this.$store.commit('MSDAT_STORE/SET_PAYLOAD', {
      //   controlIndex,
      //   key: 'location',
      //   value: this.dlGetLocation(1),
      // });
    },

    // Get available DataSources
    async setDataSourcesDropdown(indicatorID = this.defaultIndicator.id) {
      const data = await this.getDataSourcesFromIndicator(indicatorID);
      return data;
    },
    // Get available Indicator
    async setIndicatorDropdown(datasourceID = this.defaultDataSource.id) {
      const data = await this.getIndicatorsFromDatasource(datasourceID);

      const formattedData = groupIndicator(
        this.filterCustomDashboardIndicators(data),
        'program_area',
      );
      return formattedData;
    },

    async setAllIndicatorDropdown(indicators) {
      const formattedData = groupIndicator(indicators, 'program_area');
      return formattedData;
    },

    async setAllIDCIndicators(datasourceID = this.defaultDataSource.id) {
      return this.getIndicatorsFromDatasource(datasourceID);
    },

    async setIDCIndicatorDropdown(datasourceID = this.defaultDataSource.id) {
      const data = await this.getIndicatorsFromDatasource(datasourceID);

      const formattedData = groupIndicator(
        this.filterCustomDashboardIndicators(data),
        'program_area',
      );
      return formattedData;
    },
  },
};
